import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { 
  ArrowBack, 
  Close, 
  Help 
} from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { 
  Alert,
  Box, 
  Container, 
  FormControl, 
  IconButton, 
  InputLabel, 
  OutlinedInput, 
  Snackbar, 
  Typography 
} from '@mui/material'

import { useResetPassword } from '../hooks/auth'

export default function Forgot() {
  const [sendResetEmail, resetLoading, resetError, clearResetError] = useResetPassword()
  const [email, setEmail] = useState<string>('')

  const handleForgotPassword = async () =>
    sendResetEmail(email)

  return (
    <Container maxWidth="xs">
      <Box ml={-1} mt={1}>
        <IconButton 
          component={RouterLink} 
          to="/login"
          aria-label="delete" 
          size="large"
        >
          <ArrowBack />
        </IconButton>
      </Box>

      <Box 
        mt={1} 
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Help fontSize="large" color="disabled" />
        <Typography variant="h6" component="h1" ml={2}>
          Glömt lösenordet?
        </Typography>
      </Box>

      <Typography variant="body1" component="p" mt={1}>
        Fyll i din mail och följ sedan instruktionerna för att återställa ditt lösenord.
      </Typography>
      
      <FormControl fullWidth sx={{ mt: 2 }} variant="outlined">
        <InputLabel htmlFor="email" error={!!resetError}>E-post</InputLabel>
        <OutlinedInput
          id="email"
          label="E-post"
          onChange={e => setEmail(e.target.value)}
          onKeyUp={e => e.key === 'Enter' && handleForgotPassword()}
          disabled={resetLoading}
          error={!!resetError}
        />
      </FormControl>

      <Box mt={2}>
        <LoadingButton
          fullWidth
          size="large"
          loading={resetLoading}
          variant="contained"
          disabled={resetLoading}
          onClick={handleForgotPassword}
        >
          Skicka
        </LoadingButton>
      </Box>

      <Snackbar 
        open={!!resetError} 
        autoHideDuration={6000} 
        onClose={clearResetError}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={clearResetError}
            >
              <Close />
            </IconButton>
          }
        >
          {resetError?.email}
          {resetError?.password}
          {resetError?.other}
        </Alert>
      </Snackbar>
    </Container>
  )
}
